<template lang="pug">
  .side-bar(:class="{open, hide}")
    .toggle(@click="toggle")
      i(:class="{open}").el-icon-d-arrow-left
    .panel
      .blocks
        panel-block(title="Sections", :dark="true")
          .section-row(v-for="({label, value, property},i) in getSectionDataDisplay", :key="i")
            label {{label}}
            el-switch.lei-switch.small(active-color="#51dac5"
            inactive-color="#858585",
            :value="value",
            @change="toggleDisplaySections({property})")
</template>
<script>
import { mapGetters, mapMutations, mapState, } from 'vuex'
import { TOGGLE_DISPLAY_SECTION, } from '../../store/modules/record/mutations-types'
import PanelBlock from '../lei-components/PanelBlock'

export default {
  components: { PanelBlock, },
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      open: false,
    }
  },
  computed: {
    getSectionDataDisplay () {
      if (this.$route.params.currentTab === 'record_modifications') {
        return this.sectionModificationDisplay
      }
      return this.sectionsDisplay
    },

    ...mapState('record', [ 'showEmptyFields', ]),
    ...mapGetters('record', [ 'sectionsDisplay', 'sectionModificationDisplay', ]),
  },
  methods: {
    toggle () {
      this.open = !this.open
    },

    ...mapMutations('record', {
      toggleDisplaySections: TOGGLE_DISPLAY_SECTION,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"

  .side-bar
    display flex
    position fixed
    top 25vh
    right -400px
    z-index 99
    transition all .3s ease-in-out
    &.open
      right -14px
      .panel
        box-shadow: -11px 11px 20px -2px rgba(0, 0, 0, 0.15), -5px 5px 10px -2px rgba(0, 0, 0, 0.2)
      .toggle
        box-shadow: -11px 11px 20px -2px rgba(0, 0, 0, 0.15), -5px 5px 10px -2px rgba(0, 0, 0, 0.2)

    .panel
      max-height 73vh
      background-color $cyprus-color
      padding 30px 0 30px 30px
      width 400px
      transition all .2s ease-in-out
      box-shadow 0
      overflow-x hidden
      .blocks
        max-height 100%
        padding-right 30px
        overflow-y scroll
      .dark .section-row
        color $white-color
      .section-row
        display flex
        justify-content space-between
        align-items center
        color $default-color-bold
        padding 5px 0
        margin-top 2px
        min-height 30px
        border-bottom 1px solid $default-color-light-2
        label
          font-weight 600


    .toggle
      cursor pointer
      top 0
      left -60px
      position absolute
      width 60px
      height 50px
      display flex
      align-items center
      justify-content center
      background-color $cyprus-color
      transition all .2s ease-in-out
      box-shadow: -6px 5px 20px rgba(0, 0, 0, 0.15), -2px 2px 10px -1px rgba(0, 0, 0, 0.2)

      i
        margin-right 5px
        color $turquoise-color
        font-size 1.75rem
        font-weight bold
        transition all .4s ease-in-out
        &.open
          margin-right 0
          transform rotate(180deg)

  .hide
    transform: translate(500px, 0);

  @media (max-width: $tablet)
    .side-bar
      display none
</style>



// WEBPACK FOOTER //
// src/components/layout-components/SideBarPanel.vue